import React from 'react';

import ErrorBanner from './Error';
import Header from './Header';

import Participants from 'components/Participants';
import Place from 'components/Place';
import Dates from 'components/Dates';

class Invite extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      userId: this.props.userId,
      status: this.props.invite.status,
      participants: this.props.invite.participants,
      place: this.props.invite.place,
      dates: this.props.invite.dates,
      error: null
    };
  }

  render() {
    return (
      <React.Fragment>
        <ErrorBanner message={this.state.error} />
        <Header userId={this.state.userId} status={this.state.status} participants={this.state.participants} />
        <Participants participants={this.state.participants} />
        <Place place={this.state.place} />
        <Dates dates={this.state.dates} status={this.state.status} participants={this.state.participants} />
      </React.Fragment>
    );
  }
}

export default Invite;
